import React from 'react';

import classes from './Button.scss';

const button = (props) => {
    return (
        <button {...props} className={[classes.Button, classes[props.theme], classes[props.width], classes[props.type]].join(' ')}>
            <span className={classes.Text}>{props.children}</span>
        </button>
    );
};

export default button;


// WEBPACK FOOTER //
// ./src/components/UI/Button/Button.js